<template>
  <gg-card>
    <gg-card-header>
      Manage Subdomains
      <template>
        <gg-text-field outlined
                       v-model="search"
                       append-icon="mdi-magnify"
                       single-line
                       hide-details
                       class="float-right"
        />
      </template>
    </gg-card-header>
    <gg-card-text>
      <v-data-table :headers="headers"
                    :loading="loading"
                    :search="search"
                    :items="items"
      >
<!--        <template v-slot:item.basedir="{ item }">-->
<!--          &lt;!&ndash; TODO: add router link to FileManager &ndash;&gt;-->
<!--          <a href="javascript:void(0)" title="File Manager">-->
<!--            <v-icon small class="pb-1">mdi-home</v-icon> {{ item.basedir }}-->
<!--          </a>-->
<!--          <a href="javascript:void(0)"-->
<!--             title="Change Document Root" @click="openModal('docroot', props.item)">-->
<!--            <v-icon small class="pb-1 pl-2">mdi-pencil</v-icon>-->
<!--          </a>-->
<!--        </template>-->
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <gg-btn v-bind="attrs" v-on="on">
                Manage
                <v-icon class="ml-1">mdi-chevron-down</v-icon>
              </gg-btn>
            </template>
            <v-list>
              <v-list-item @click="openModal('redirection', item)">
                <v-list-item-title>
                  Manage Redirection
                </v-list-item-title>
              </v-list-item>
              <!-- Sub-domain that is associated with an addon domain cannot be removed -->
              <v-list-item @click="openModal('delete', item)">
                <v-list-item-title>
                  Remove
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>

      <change-doc-root-modal :selected-domain="selectedItem"
                             :opened="modals.docroot"
                             v-if="modals.docroot"
                             @docroot-updated="reload"
                             @close="closeModal('docroot')"
      />
      <delete-subdomain-modal :subdomain="selectedItem"
                              v-if="modals.delete"
                              :opened="modals.delete"
                              @addondomain-removed="reload"
                              @close="closeModal('delete')"
      />
      <manage-redirection-modal :hosting-domain="selectedItem"
                                v-if="modals.redirection"
                                :opened="modals.redirection"
                                @redirection-updated="reload"
                                @redirection-removed="reload"
                                @close="closeModal('redirection')"
      />
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import reloadable from '@/mixins/tableShouldBeReloaded'
import modalsTable from '@/mixins/modalsTable'
import ChangeDocRootModal from '../ChangeDocRootModal'
import DeleteSubdomainModal from './DeleteSubdomainModal'
import ManageRedirectionModal from '../ManageRedirectionModal'

export default {
  name: 'SubdomainsTable',
  components: {
    ChangeDocRootModal,
    DeleteSubdomainModal,
    ManageRedirectionModal,
  },
  mixins: [
    reloadable,
    modalsTable,
  ],
  data () {
    return {
      loading: false,
      search: '',
      headers: [
        {
          text: 'Subdomains',
          value: 'domain',
        },
        // {
        //   text: 'Document Root',
        //   value: 'basedir',
        // },
        // {
        //   text: 'Redirection',
        //   value: 'status',
        // },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ],
      modals: {
        docroot: false,
        delete: false,
        redirection: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      subdomains: 'hostingDomains/subdomains',
      hostingAddonDomains: 'hostingDomains/hostingAddonDomains'
    }),
    items () {
      return this.subdomains.filter(sub => {
        return this.hostingAddonDomains.findIndex(ad => ad.domainkey === sub.domainkey) === -1
      })
    }
  },
  methods: {
    ...mapActions({
      getHostingSubdomains: 'hostingDomains/getHostingSubdomains',
      getHostingAddonDomains: 'hostingDomains/getHostingAddonDomains',
      reportError: 'reportError'
    }),
    async reload () {
      this.loading = true
      try {
        await this.getHostingAddonDomains(this.$route.query.user)
        await this.getHostingSubdomains(this.$route.query.user)
        this.$emit('table-reloaded')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
  created () {
    this.reload()
  }
}
</script>
